const CUSTOM_FIELDS_TABLE_TYPES = Object.freeze({
  object: 'object',
  customField: 'customField',
  link: 'link',
  task: 'task',
} as const)

export default CUSTOM_FIELDS_TABLE_TYPES
